
import { useState } from 'react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddPopup from '../list/add-popup'
import AddItemPopup from '../list/add-items'

const StockSupplyMainPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, tabIndex = null }) => {
    const [navIndex] = useState(tabIndex || 0);


    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.stockSupplyModal}`}>
                    {navIndex == 0 &&
                        <AddPopup
                            onClose={onClose}
                            onError={onError}
                            onSubmit={onSubmit}
                            currentData={currentData}
                            dropdowns={dropdowns}
                            Style={Style}
                        />
                    }

                    {navIndex == 1 &&
                        <AddItemPopup
                            onClose={onClose}
                            onError={onError}
                            onSubmit={onSubmit}
                            currentData={currentData}
                            dropdowns={dropdowns}
                            Style={Style}
                        />
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default StockSupplyMainPopup
